import styled from "styled-components";
export const LeaveReqAdminStyle = styled.div`
  color: ${({ theme }) => theme.text};
`;
